<template>
    <div>
        <v-app
            id="main-background"
            style="background: #bdbdbd !important;"
            v-bind:class="{
                loginBackground: !getCampaignName(),
            }"
        >
            <div
                v-if="getCampaignImage()"
                style="
                    width: 100%;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                "
                v-bind:style="{
                    'background-image': 'url(' + getCampaignImage() + ')',
                }"
                v-bind:class="{
                    'mobile-header-image': responsive,
                    'header-image': !responsive,
                }"
            ></div>
            <v-toolbar
                v-if="!getCampaignName()"
                class="header"
                v-bind:class="{
                    'mb-9': responsive,
                    'mb-12 mt-3': !responsive,
                }"
            >
                <v-layout justify-center align-center class="pt-12">
                    <v-img
                        v-if="responsive"
                        class="mr-2"
                        style="max-width: 85px;"
                        src="https://utaw.blob.core.windows.net/images/logo+uta11.png"
                        height="51"
                        width="50"
                        contain
                    />
                    <v-img
                        v-if="!responsive"
                        class="mr-5"
                        style="max-width: 85px;"
                        src="https://utaw.blob.core.windows.net/images/logo+uta11.png"
                        height="81"
                        width="80"
                        contain
                    />
                    <div
                        class="mr-5 mt-3 main-header"
                        style="color: #fff"
                        v-bind:class="{ 'main-header-mobile': responsive }"
                    >
                        UTA Payment System
                    </div>
                </v-layout>
            </v-toolbar>
            <router-view style="width: 960px; z-index: 1;"></router-view>
            <v-footer style="background: #bdbdbd">
                <v-layout justify-center v-if="!getCampaignName()">
                    <v-btn
                        color="#389466"
                        class="mb-8 mt-0"
                        outlined
                        @click="openContactUsDialog"
                        >Contact Us</v-btn
                    >
                </v-layout>
            </v-footer>
        </v-app>
        <v-dialog v-model="contactUsDialog" persistent max-width="500">
            <v-card class="pa-4">
                <div v-if="messageSent" class="mb-4">
                    <v-card-title class="pb-2 px-0 pt-0"
                        >Thank You!</v-card-title
                    >
                    <div class="body-2">
                        Your message is very important to us. We will get back
                        to you ASAP
                    </div>
                </div>
                <div v-else>
                    <v-card-title class="pb-2 pl-1 pt-0" style="color: #389466;"
                        >Contact Us</v-card-title
                    >
                    <v-select
                        class="px-1"
                        v-model="selectedCampaign"
                        :items="campaignList"
                        label="Department"
                        ref="selectedCampaign"
                        item-text="displayName"
                        item-value="id"
                        :rules="[required]"
                        color="#389466"
                        return-object
                        single-line
                    ></v-select>
                    <v-text-field
                        class="px-2"
                        label="Name"
                        color="#389466"
                        v-model="contactUsName"
                        ref="contactUsName"
                        :rules="[required]"
                    ></v-text-field>
                    <v-text-field
                        class="px-2"
                        label="Email"
                        color="#389466"
                        v-model="contactUsEmail"
                        :rules="emailRules"
                        ref="contactUsEmail"
                    ></v-text-field>
                    <v-text-field
                        class="px-2"
                        color="#389466"
                        label="Phone Number"
                        v-model="contactUsPhone"
                        :rules="[
                            (v) => !!v || 'A Valid Phone Number Is Required.',
                            (v) =>
                                !v ||
                                ([10, 11].includes(
                                    v.replace(/-/g, '').length
                                ) &&
                                    /^\d+$/.test(v)) ||
                                'A Valid Phone Number Is Required.',
                        ]"
                        ref="contactUsPhone"
                    ></v-text-field>
                    <v-textarea
                        class="px-2"
                        solo
                        color="#389466"
                        v-model="contactUsMessage"
                        label="Message"
                        ref="contactUsMessage"
                        :rules="[required]"
                    ></v-textarea>
                    <v-card-text v-if="contactUsError" class="pt-0 error--text">
                        {{ contactUsError }}
                    </v-card-text>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#389466" outlined @click="closeContactUs"
                        >Close</v-btn
                    >
                    <v-btn
                        v-if="!messageSent"
                        class="button"
                        :loading="sending"
                        @click="contactUS"
                        >Send</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";

export default {
    name: "App",

    // components: {
    //     HelloWorld
    // },

    data: () => ({
        //
        contactUsDialog: false,
        contactUsError: "",
        contactUsName: "",
        contactUsEmail: "",
        contactUsPhone: "",
        contactUsMessage: "",
        sending: false,
        messageSent: false,
        campaignList: [],
        selectedCampaign: "",

        required: (value) => !!value || "Required.",

        emailRules: [
            (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return !value || pattern.test(value) || "Invalid e-mail.";
            },
            (value) => !!value || "Required",
        ],

        responsive: false,

        campaignName: "",
    }),
    async created() {
        this.campaignName = this.$route.params.id;

        await this.loadCampaignNames();
    },
    mounted() {
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted);
    },
    methods: {
        getCampaignName() {
            return this.$store.state.app.campaignName;
        },
        getCampaignImage() {
            return this.$store.state.app.campaignImage;
        },
        onResponsiveInverted() {
            if (window.innerWidth < 551) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        async loadCampaignNames() {
            const campaigns = await this.$http.get(
                "api/Campaign/GetCampaignNames"
            );

            this.campaignList = campaigns.filter(
                (c) => c.active && c.allowContact
            );

            this.campaignList.push({
                name: "Other",
                displayName: "General",
                active: true,
                allowContact: true,
            });
        },
        openContactUsDialog() {
            if (
                this.$store.state.app.donor &&
                this.$store.state.app.donor.firste
            ) {
                this.contactUsName =
                    this.$store.state.app.donor.firste +
                    " " +
                    this.$store.state.app.donor.laste;
            }

            if (this.$store.state.app.phone) {
                this.contactUsPhone = this.$store.state.app.phone;
            }

            if (this.$store.state.app.manual) {
                this.contactUsName = this.$store.state.app.manual.name;
                this.contactUsPhone = this.$store.state.app.manual.phone;
                this.contactUsEmail = this.$store.state.app.manual.email;
            }

            this.contactUsDialog = true;
        },
        closeContactUs() {
            this.contactUsDialog = false;
            this.contactUsError = "";
            this.contactUsName = "";
            this.contactUsEmail = "";
            this.contactUsMessage = "";
            this.contactUsPhone = "";

            this.messageSent = false;
        },
        async contactUS() {
            if (
                ![
                    this.$refs.contactUsName.validate(true),
                    this.$refs.contactUsEmail.validate(true),
                    this.$refs.contactUsPhone.validate(true),
                    this.$refs.contactUsMessage.validate(true),
                    this.$refs.selectedCampaign.validate(true),
                ].every(Boolean)
            )
                return;

            this.sending = true;

            try {
                await this.$http.post("api/account/contactUS", {
                    name: this.contactUsName,
                    email: this.contactUsEmail,
                    phone: this.contactUsPhone,
                    category: this.selectedCampaign.name,
                    message: this.contactUsMessage,
                });

                this.sending = false;
                this.messageSent = true;
            } catch (e) {
                this.sending = false;

                this.contactUsError = "Error sending message.";
            }
        },
    },
};
</script>
<style>
.campaign-background {
    background: #bdbdbd !important;
} /*
.campaign-background:after {
    background-image: url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/images/loginid140313/a45242d408102da0012181b2f3cc0a7b_1603302692.jpeg");
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 30%;

    z-index: 0;
}*/
.loginBackground {
    background: #bdbdbd !important;
    /*background: transparent
        radial-gradient(closest-side at 50% 50%, #004396 0%, #003152 100%) 0% 0%
        no-repeat padding-box !important;*/
}
.loginBackground:after {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 30%;
    background: #389466 !important;
    z-index: 0;
}
.header {
    z-index: 2 !important;
    background-color: unset !important;
    box-shadow: none !important;
    max-height: 64px;
}
.bsd {
    text-align: left !important;
    font: Bold 20px/18px Roboto;
    letter-spacing: 0 !important;
    color: #fff !important;
}
.contact-us-button {
    color: #389466 !important;
}
.button {
    text-align: left !important;
    font: Medium 14px/20px Roboto;
    letter-spacing: 0 !important;
    color: #ffffff !important;
    background: #389466 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 2px 2px #0000003d;
    border-radius: 2px;
    opacity: 1;
}
@font-face {
    font-family: "uta-font";
    src: url(assets/fonts/Revue.eot);
    src: url(assets/fonts/Revue.eot?#iefix) format("embedded-opentype"),
        url(assets/fonts/Revue.woff) format("woff"),
        url(assets/fonts/Revue.ttf) format("truetype");
}

.main-header {
    font-family: "uta-font" !important;
    font-size: 3.75rem !important;
    font-weight: 300 !important;
}
.main-header-mobile {
    font-family: "uta-font" !important;
    font-size: 1.5rem !important;
    font-weight: 300 !important;
}
.mobile-header-image {
    height: 210px !important;
}
.header-image {
    height: 358px !important;
}
</style>
